import { render } from "./Header.vue?vue&type=template&id=56cf4169&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=56cf4169&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/changlei/roblox-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56cf4169"]])

export default __exports__